import { FC } from "react";
import { Flex, Text } from "@storyofams/react-ui";
import { shopifyToIntlPrice } from "~lib";
import { ProductByHandleQuery } from "~lib/shopify/sdk";

const getDiscountPrice = (discount, price) => {
  return (Number(price) - (Number(price) * Number(discount)) / 100).toFixed(2);
};

interface OptionPriceProps {
  option: ProductByHandleQuery["productByHandle"]["variants"]["edges"][0]["node"];
  autoDiscount: string | null;
}

export const OptionPrice: FC<OptionPriceProps> = ({ autoDiscount, option }) => {
  if (autoDiscount) {
    const discountedPrice =
      "€" + getDiscountPrice(autoDiscount, option.priceV2.amount);
    const discountedUnitPrice = option.unitPrice
      ? "€" + getDiscountPrice(autoDiscount, option.unitPrice.amount)
      : 0;
    return (
      <Flex alignItems={["end", "center"]} flexDirection={["column", "row"]}>
        {option.unitPrice && (
          <Text
            order={[1, 0]}
            fontSize={"12px"}
            mr={[0, "12px"]}
            color="#1D1D1B"
          >
            {discountedUnitPrice} / {option.unitPriceMeasurement.referenceUnit}
          </Text>
        )}
        <Flex order={[0, 1]}>
          <Text
            fontWeight={[500, 600]}
            color="#1D1D1B"
            fontSize={"14px"}
            textDecoration={"line-through"}
            opacity={"40%"}
          >
            {shopifyToIntlPrice(option.priceV2)}
          </Text>
          <Text
            fontWeight={[500, 600]}
            color="#1D1D1B"
            fontSize={"14px"}
            ml="2px"
          >
            {discountedPrice}
          </Text>
        </Flex>
      </Flex>
    );
  }
  return (
    <Flex alignItems={["end", "center"]} flexDirection={["column", "row"]}>
      {option.unitPrice && (
        <Text order={[1, 0]} fontSize={"12px"} mr={[0, "12px"]} color="#1D1D1B">
          {shopifyToIntlPrice(option.unitPrice)} /{" "}
          {option.unitPriceMeasurement.referenceUnit}
        </Text>
      )}
      <Flex order={[0, 1]}>
        {option.compareAtPriceV2 && (
          <Text
            fontWeight={[500, 600]}
            color="#1D1D1B"
            fontSize={"14px"}
            textDecoration={"line-through"}
            opacity={"40%"}
          >
            {shopifyToIntlPrice(option.compareAtPriceV2)}
          </Text>
        )}
        <Text
          fontWeight={[500, 600]}
          color="#1D1D1B"
          fontSize={"14px"}
          ml="2px"
        >
          {shopifyToIntlPrice(option.priceV2)}
        </Text>
      </Flex>
    </Flex>
  );
};
